import { render, staticRenderFns } from "./PrenotazioneDialog.vue?vue&type=template&id=59987340&scoped=true&"
import script from "./PrenotazioneDialog.vue?vue&type=script&lang=js&"
export * from "./PrenotazioneDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrenotazioneDialog.vue?vue&type=style&index=0&id=59987340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59987340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Repository/SPRAYER_MANAGER/SPRAYER_MANAGER_SITO/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VFlex,VIcon,VLayout,VProgressCircular,VRadio,VRadioGroup,VTextarea,VTooltip})
